module.exports = __webpack_public_path__ + "media/assets/images/sunny_later_will_cloudy-9fbb1930ee7574f91d1748a7ce91809f.png";